import globalEvents from '../../utils/globalEvent'
;(function (window) {
  var api_id = 0 // 自增的api_id，用于找到对应回应
  var req_count = 0 // 记录请求次数
  var core_version // 当前版本号
  var callback_list = {}
  var ready_callback_list = []
  var error_callback_list = []
  var is_ready
  var is_error

  /**
   * 请求接口前验证合法性
   * @link http://inside.intsig.net/webapi/#1757-en
   */
  var CCJSAPI = {}

  function ready(callback) {
    if (is_ready) {
      callback()
    } else {
      ready_callback_list.push(callback)
    }
  }

  function _fire(type) {
    var tmp_array = type === 'error' ? error_callback_list : ready_callback_list
    for (var i = 0, length = tmp_array.length; i < length; i++) {
      tmp_array[i] && tmp_array[i]()
    }
  }

  function error(callback) {
    if (is_error) {
      callback()
    } else {
      ready_callback_list.push(callback)
    }
  }

  function log(data) {
    if (!CCJSAPI.is_debug || !data) {
      return
    }
  }

  function getAppInfo() {
    return {
      client_app: 'camcard_web',
      vendor: '123',
      language: 'zh-cn'
    }
  }

  function init(error) {
    if (error) {
      // 记录日志
      log('ERROR ' + '[' + error + '] ' + location.href)
      return
    }
    var support_list = getSupportApiList()
    for (var i in support_list) {
      CCJSAPI[support_list[i]] = function () {
        return true
      }
    }
  }

  init()

  function config(timestamp, signature, is_debug) {
    if (is_ready) {
      return
    }
    CCJSAPI.is_debug = is_debug || getUrlParam('_js_debug') || false
    // 判断是否超时，超时时间为3s
    if (req_count < 6) {
      // 判断CCBJSAPI是否写入
      if (typeof CCBJSAPI === 'undefined') {
        // eslint-disable-line no-undef
        setTimeout(function () {
          req_count++
          config(timestamp, signature)
        }, 500)
        return
      }
    } else {
      init('time out')
      _fire('error')
      is_error = 1
      return
    }
    // 验证合法性
    core_version = CCBJSAPI.config(
      JSON.stringify({
        // eslint-disable-line no-undef
        timestamp: timestamp,
        signature: signature
      })
    )

    if (!core_version) {
      init('verify fail')
      _fire('error')
      is_error = 1
      return
    }

    var support_list = getSupportApiList()
    for (var i in support_list) {
      ;(function (action) {
        CCJSAPI[action] = function (params, callback) {
          var tmp_params = JSON.parse(JSON.stringify(params || {}))
          tmp_params.data = tmp_params.data || {}
          if (action === 'jump') {
            if (tmp_params.data.animation === 0) {
              tmp_params.data.animation = '0'
            } else {
              tmp_params.data.animation = '1'
            }
          }
          tmp_params.close_web = tmp_params.close_web ? '1' : '0'

          var id = getApiId()
          var api_data = {
            id: id,
            action: action,
            data: tmp_params.data,
            close_web: tmp_params.close_web
          }

          if (tmp_params.view) {
            api_data.view = tmp_params.view
          }
          log(JSON.stringify(api_data))
          CCBJSAPI.callApp(JSON.stringify(api_data)) // eslint-disable-line no-undef

          if (callback) {
            callback_list[id] = callback
          }
        }
      })(support_list[i])
    }
    CCJSAPI['getAppInfo'] = function (params) {
      var tmp_params = JSON.parse(JSON.stringify(params || {}))
      tmp_params.data = tmp_params.data || {}
      tmp_params.close_web = tmp_params.close_web ? '1' : '0'
      var log_data = JSON.parse(JSON.stringify(tmp_params))
      log_data.action = 'getAppInfo'
      log(JSON.stringify(log_data))
      return JSON.parse(CCBJSAPI.getAppInfo(JSON.stringify(tmp_params))) // eslint-disable-line no-undef
    }
    is_ready = true
    CCBJSAPI.callWeb = callWeb // eslint-disable-line no-undef
    CCBJSAPI.notify = notify // eslint-disable-line no-undef
    log('init ok')
    _fire('ready')
    log('ready')
  }

  function getApiId() {
    api_id++
    return api_id
  }

  function getSupportApiList() {
    return [
      'login',
      'share',
      'toast',
      'jump',
      'select_image',
      'close_share',
      'capture',
      'location',
      'pay',
      'update_token',
      'close_view',
      'web_verify',
      'navigation',
      'email',
      'jump_miniprogram',
      'is_login',
      'get_device_id',
      'update_vip_count_down',
      'custom_config',
      'get_custom_app_info',
      'complete_person_info',
      'callApp',
      'register',
      'save_image',
      'system_privacy_settings'
    ]
  }

  // 客户端回调接口
  function callWeb(data) {
    log(data)
    try {
      data = JSON.parse(data)
    } catch (e) {
      log('Json解析失败.')
    }
    var action_id = data.id
    if (callback_list[action_id]) {
      callback_list[action_id].call(window, data)
      delete callback_list[action_id]
    }
  }

  function getUrlParam(key, s) {
    var pos, i, length, val, query, list, item
    if (!s) {
      s = location.href
    }
    s = s.replace(/#.+$/, '') // 去掉hash值
    pos = s.indexOf('?')
    if (pos > -1) {
      s = s.substring(pos, s.length)
    }

    if (s.substr(0, 1) === '?' && s.length > 1) {
      query = s.substring(1, s.length)
      list = query.split('&')
      for (i = 0, length = list.length; i < length; i++) {
        item = list[i].split('=')
        var vals = item.slice(1)
        if (item[0] === key && item.length >= 2) {
          val = vals.join('=')
          return val
        }
      }
    }
  }

  // 客户端回调接口
  function notify(data) {
    data = JSON.parse(data)
    const eventName = data.event_name
    if (eventName === 'backAction') {
      globalEvents.vipLeaveDialog()
      globalEvents.svipLeaveDialog()
    } else if (eventName === 'applicationWillEnterForeground') {
      globalEvents.pageWillAppear()
    } else if (eventName === 'vipBuySuccess') {
      globalEvents.vipBuySuccess()
    }
  }

  CCJSAPI.getAppInfo = getAppInfo
  CCJSAPI.config = config
  CCJSAPI.log = log
  CCJSAPI.ready = ready
  CCJSAPI.error = error
  window.CCJSAPI = CCJSAPI
})(window)
export default CCJSAPI
